// For testing purposes, move this into it's own file to more easily mock
export const triggerPrompt = (e: BeforeUnloadEvent, condition: boolean): void => {
  // Modern browsers don't allow custom messages anymore, but you still need to set e.returnValue to a string to trigger
  if (condition) {
    e.preventDefault();
    e.returnValue = '';
  }
};

export default { triggerPrompt };
